const API_BASE_URL = (
  process.env.REACT_APP_API_BASE_URL ||
  'https://dangkyhosodoanhnghiepgov.com'
).replace(/\/+$/, '');

export const apiEndpoint = (path) =>
  `${API_BASE_URL}/${String(path).replace(/^\/+/, '')}`;

export default API_BASE_URL;
